import { productDetailsContainerSX } from '@/components/blocks/ProductDetails/styles/container';
import { Stack, Skeleton } from '@mui/material';

interface Props {
	isMobile: boolean;
}

export const ProductDetailsSkeleton: React.FC<Props> = ({ isMobile }) => (
	<Stack spacing="20px" sx={productDetailsContainerSX({ isMobile })}>
		<Skeleton variant="rounded" width="100%" height={30} />
		<Skeleton variant="rounded" width="90%" height={20} />
		<Skeleton variant="rounded" width="80%" height={10} />
	</Stack>
);
